export enum VehicleStates {
  New = 1, // Neuf
  Used = 2, // Occasion
}
